<template>
	<dialog-slot
			:title="`Send to ${customer}`"
			@updateClose="onCloseDialog"
			@updateSave="onSave"
			width="580px"
			apply-text="Send list"
	>

		<div v-if="isFrozen" class="isFrozen">
			<div class="bgIcon">
				<div class="icon"><svg-sprite icon-id="warning" width="100%" height="100%"/></div>
				<div class="icon"><svg-sprite icon-id="warning" width="100%" height="100%"/></div>
				<div class="icon"><svg-sprite icon-id="warning" width="100%" height="100%"/></div>
			</div>
			<div class="frozenTitle">
				<svg-sprite icon-id="attention" width="24" height="24"/>
				<span>Attention</span>
			</div>
			<div class="frozenText">
				You are about to send a message to customer <b>{{customer}}</b>,<br>
				who currently has <b>Frozen</b> status.
			</div>
		</div>

		<!--				User Settings -->
		<card-slot
				title="Send list settings"
				icon="setting"
		>
			<div class="cardSlotMain">
				<field
						margin="0"
						label="Email"
						placeholder="Enter email"
						@updateInput="onInput($event, 'email')"
						:setInputValue="email"
						is-required
						isClip
						:classError="!!errors.email"
						:textError="errors.email"
				/>

				<div class="rowSwitch">
					<field
							margin="0"
							padding="0"
							height="24"
							:switch-value="!!send_sms"
							@updateSwitch="onCheckbox($event, 'send_sms')"
							label-switch="Send sms"
							is-dense
							is-switch
							is-off-style
					></field>

					<field
							margin="0"
							padding="0"
							height="24"
							:switch-value="!!send_invoice"
							@updateSwitch="onCheckbox($event, 'send_invoice')"
							label-switch="Send invoice"
							is-dense
							is-switch
							is-off-style
					></field>

					<field
							margin="0"
							padding="0"
							height="24"
							:switch-value="!!send_report"
							@updateSwitch="onCheckbox($event, 'send_report')"
							label-switch="Send report"
							is-dense
							is-switch
							is-off-style
					></field>
				</div>

				<div v-if="errors.switches" class="error--text caption">
					{{ errors.switches }}
				</div>

				<field
						margin="0"

						label="Template"
						placeholder="Select template"
						@updateSelect="onAutocomplete"
						:autocompleteValue="template"
						:items="templates"
						:isClearable="false"
						is-select
				></field>
			</div>

		</card-slot>

	</dialog-slot>
</template>

<script>
import { mapActions } from "vuex";
// components
import DialogSlot from "@/shared/DialogSlot/DialogSlot.vue";
import CardSlot from "@/shared/CardSlot/CardSlot.vue";

export default {
	name: "SendReports",
	components: { CardSlot, DialogSlot },
	computed: {
	},
	props: {
		sendReportsData: Object
	},
	data: () => ({
		send_invoice: true,
		send_sms: false,
		send_report: false,
		template: 1,
		selectedReports: [],
		templates: [
			{ id: 1, value: 'Standard' },
			{ id: 2, value: 'Remind' },
			{ id: 3, value: 'Information' },
			{ id: 4, value: 'Safety #' },
			{ id: 5, value: 'ELD migration' },
			{ id: 6, value: 'SMS phone' }
		],
		email: null,

		customer: null,
		invoice_id: null,
		errors: {
			email: '',
			switches: ''
		}
	}),
	methods: {
		...mapActions([ 'onSendInvoice', 'setAlert', 'actionPreloader' ]),
		onAutocomplete({ value }) {
			this.template = value && value.id ? value.id : value;

			// якщо шаблон 3 або 4 — світчі не обовʼязкові, прибираємо помилку
			if (this.template === 3 || this.template === 4) {
				this.errors.switches = '';
			}
		},
		onCheckbox({ value }, key) {
			this[key] = value;

			// прибираємо помилку по світчах если шото вибрано
			if (value) {
				this.errors.switches = '';
			}
		},
		// onInput({ value, idx }, key) {
		// 	console.log('%c [  key  ] ', 'color:#bada55', typeof key, key );
		//
		// 	this.selectedReports[idx].email = value;
		// },
		onInput({ value }, key) {
			this[key] = value;
			if (key === 'email') {
				this.errors.email = '';
			}
		},
		onCloseDialog(value) {
			this.$emit("updateSendReportsClose", value);
		},
		isEmailValid(email) {
			const v = (email || '').trim();
			return /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(v);
		},
		async onSave() {
			// сброс
			this.errors.email = '';
			this.errors.switches = '';

			const checkBoxValid = this.send_invoice || this.send_report || this.send_sms;
			const isTemplateNoNeedSwitches = (this.template === 3 || this.template === 4);

			let hasError = false;

			// 1) свитчеры
			if (!checkBoxValid && !isTemplateNoNeedSwitches) {
				this.errors.switches = 'Select at least one option';
				hasError = true;
			}

			// 2) email
			if (!this.isEmailValid(this.email)) {
				this.errors.email = 'Email field is required';
				hasError = true;
			}

			// если есть хоть одна ошибка — выходим ПОСЛЕ обеих проверок
			if (hasError) return;

			// дальше отправка
			const values = {
				send_invoice: this.send_invoice,
				send_sms: this.send_sms,
				send_report: this.send_report,
				email: (this.email || '').trim(),
				invoice_id: this.invoice_id,
				template: this.template
			};

			this.actionPreloader(true);

			const resp = await this.onSendInvoice(values);
			const status = resp && resp.status;

			if (status) {
				this.setAlert({ type: "success", message: "Reports sent successfully" });
				this.onCloseDialog(1);
			} else {
				this.setAlert({ type: "error", message: "Reports sent error" });
				this.actionPreloader(false);
			}
		}

	},
	created() {
		const d = this.sendReportsData || {};
		this.customer = d.customer;
		this.invoice_id = d.invoice_id;
		this.email = d.email || null;
		this.isFrozen = d.frozen;
	}
};
</script>

<style scoped lang="scss">
.cardSlotMain {
	display: flex;
	flex-direction: column;
	gap: 10px;
	.cardSlotMainHead {
		.employeesCompany {
			display: grid;
			grid-template-columns: 3fr 2fr auto;
			grid-gap: 10px;
		}
	}
	.rowSwitch {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 10px;
	}
}
.isFrozen {
	margin-bottom: 10px;
	position: relative;
	.frozenTitle {
		gap: 4px;
		display: flex;
		align-items: center;
		position: relative;
		z-index: 10;
		font-size: 16px;
		svg {
			color: var(--base-green);
		}
	}
	.frozenText {
		position: relative;
		z-index: 10;
	}
	.bgIcon {
		position: absolute;
		opacity: 0.2;
		top: 0;
		transform: rotate(-12deg);
		z-index: 1;
		right: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 0px;
		.icon {
			&:nth-of-type(1) {
				svg {
					width: 80px;
					height: 80px;
				}
			}
			&:nth-of-type(2) {
				svg {
					width: 60px;
					height: 60px;
				}
			}
			&:nth-of-type(3) {
				svg {
					width: 40px;
					height: 40px;
				}
			}
		}
	}
}
</style>
